export default __webpack_public_path__ + "static/media/icono-Estacion-Blanco.e9641fe1.svg";